import React from 'react';
import {
  IonButtons,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonButton,
  useIonPopover,
} from '@ionic/react';
import { globeOutline } from 'ionicons/icons';
import { useLanguage } from '../context/LanguageContext';

export default function LanguageToggle() {
  const { language, setLanguage, t } = useLanguage();

  const LanguagePopover: React.FC<{
    onDismiss: () => void;
  }> = ({ onDismiss }) => (
    <IonList>
      <IonItem
        button
        detail={false}
        onClick={() => {
          setLanguage('vi');
          onDismiss();
        }}
      >
        <IonLabel color={language === 'vi' ? 'primary' : undefined}>
          {t('vietnamese')}
        </IonLabel>
      </IonItem>
      <IonItem
        button
        detail={false}
        onClick={() => {
          setLanguage('en');
          onDismiss();
        }}
      >
        <IonLabel color={language === 'en' ? 'primary' : undefined}>
          {t('english')}
        </IonLabel>
      </IonItem>
    </IonList>
  );

  const [present, dismiss] = useIonPopover(LanguagePopover, {
    onDismiss: () => dismiss(),
  });

  return (
    <IonButtons slot="end">
      <IonButton
        onClick={(event) =>
          present({
            event: event.nativeEvent,
          })
        }
      >
        <IonIcon icon={globeOutline} slot="icon-only" />
      </IonButton>
    </IonButtons>
  );
}
